/**
 * 百度地图 JavaScript API GL 加载器
 * 用于异步加载百度地图API，替代高德地图的 @amap/amap-jsapi-loader
 */

// 百度地图AK密钥
export const BAIDU_MAP_AK = 'QPeibpBFgeHLv28oqJCGKnpxElODNd81';

// 加载状态
let loadPromise = null;

/**
 * 异步加载百度地图 JavaScript API GL
 * @param {Object} options - 加载配置
 * @param {string} options.ak - 百度地图AK密钥
 * @param {string} options.version - API版本，默认 '1.0'
 * @returns {Promise<BMapGL>} 返回 BMapGL 对象
 */
export function loadBMapGL(options = {}) {
  const { ak = BAIDU_MAP_AK, version = '1.0' } = options;

  // 如果已经加载过，直接返回
  if (window.BMapGL) {
    return Promise.resolve(window.BMapGL);
  }

  // 如果正在加载中，返回已有的Promise
  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    // 定义全局回调函数
    const callbackName = `initBMapGL_${Date.now()}`;
    window[callbackName] = function() {
      // 清理回调函数
      delete window[callbackName];

      if (window.BMapGL) {
        resolve(window.BMapGL);
      } else {
        reject(new Error('百度地图加载失败：BMapGL 对象不存在'));
      }
    };

    // 创建script标签
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://api.map.baidu.com/api?v=${version}&type=webgl&ak=${ak}&callback=${callbackName}`;

    script.onerror = function() {
      delete window[callbackName];
      loadPromise = null;
      reject(new Error('百度地图脚本加载失败'));
    };

    document.head.appendChild(script);
  });

  return loadPromise;
}

export default {
  load: loadBMapGL,
  BAIDU_MAP_AK
};



// WEBPACK FOOTER //
// ./src/stores/location/bmap-loader.js